interface MicrosoftExcelLogoProps {
  className?: string
  style?: React.CSSProperties
}

const MicrosoftExcelLogo = ({ className, style }: MicrosoftExcelLogoProps) => (
  <div className={className} style={style}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="auto"
      height="100%"
      fill="none"
      viewBox="0 0 145 30"
    >
      <g clipPath="url(#clip0_486_39109)">
        <g clipPath="url(#clip1_486_39109)">
          <mask
            id="mask0_486_39109"
            width="24"
            height="21"
            x="0"
            y="5"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
          >
            <path fill="#fff" d="M23.086 5.216H.974v20.569h22.112z"></path>
          </mask>
          <g mask="url(#mask0_486_39109)">
            <path
              fill="#185C37"
              d="m14.858 14.987-8.742-1.543v11.399c0 .52.422.942.943.942h15.084c.52 0 .942-.422.942-.942v-4.2z"
            ></path>
            <path
              fill="#21A366"
              d="M14.858 5.216h-7.8a.943.943 0 0 0-.942.942v4.2l8.742 5.142 4.628 1.543 3.6-1.543v-5.142z"
            ></path>
            <path fill="#107C41" d="M6.116 10.357h8.742V15.5H6.116z"></path>
            <path
              fill="#000"
              d="M12.373 9.33H6.116v12.856h6.257a.946.946 0 0 0 .942-.943v-10.97a.946.946 0 0 0-.942-.943"
              opacity="0.1"
            ></path>
            <path
              fill="#000"
              d="M11.858 9.842H6.116v12.856h5.742a.946.946 0 0 0 .943-.943v-10.97a.946.946 0 0 0-.943-.943"
              opacity="0.2"
            ></path>
            <path
              fill="#000"
              d="M11.858 9.842H6.116V21.67h5.742a.946.946 0 0 0 .943-.942v-9.942a.946.946 0 0 0-.943-.943"
              opacity="0.2"
            ></path>
            <path
              fill="#000"
              d="M11.344 9.842H6.116V21.67h5.228a.946.946 0 0 0 .943-.942v-9.942a.946.946 0 0 0-.943-.943"
              opacity="0.2"
            ></path>
            <path
              fill="url(#paint0_linear_486_39109)"
              d="M1.917 9.842h9.428c.52 0 .942.422.942.943v9.428c0 .52-.422.942-.942.942H1.917a.943.943 0 0 1-.943-.942v-9.428c0-.52.422-.943.943-.943"
            ></path>
            <path
              fill="#fff"
              d="m3.894 18.563 1.982-3.072-1.816-3.056H5.52l.992 1.954q.137.279.188.415h.013a8 8 0 0 1 .205-.432l1.06-1.936h1.342l-1.863 3.038 1.91 3.09H7.941l-1.146-2.145a2 2 0 0 1-.136-.287h-.017q-.05.146-.133.278l-1.18 2.153z"
            ></path>
            <path
              fill="#33C481"
              d="M22.142 5.216h-7.286v5.142h8.228v-4.2a.943.943 0 0 0-.942-.942"
            ></path>
            <path fill="#107C41" d="M14.856 15.5h8.228v5.142h-8.228z"></path>
          </g>
          <path
            fill="currentColor"
            d="M143.188 21.277h-1.858V9.183h1.858zM139.894 17.695h-5.568q.032 1.133.694 1.747.67.614 1.835.614 1.308 0 2.401-.781v1.491q-1.118.702-2.952.702-1.802 0-2.831-1.108-1.022-1.117-1.022-3.135 0-1.907 1.125-3.104 1.133-1.204 2.809-1.204 1.674 0 2.591 1.077.919 1.077.918 2.991zm-1.787-1.308q-.008-.997-.47-1.548-.464-.558-1.276-.558a1.8 1.8 0 0 0-1.357.582q-.55.583-.678 1.524zM131.461 20.902q-.982.567-2.321.566-1.819 0-2.936-1.132-1.117-1.14-1.117-2.952 0-2.018 1.197-3.239 1.205-1.228 3.215-1.228 1.116 0 1.97.39v1.724q-.853-.638-1.818-.638-1.173 0-1.923.797-.75.79-.75 2.075 0 1.267.702 2.002.71.734 1.898.734.998 0 1.883-.71zM124.792 13.108l-2.72 4.132 2.688 4.037h-2.146l-1.436-2.53q-.135-.23-.319-.59h-.032q-.031.073-.335.59l-1.46 2.53h-2.137l2.775-4.005-2.632-4.164h2.154l1.412 2.656q.16.296.311.607h.024l1.827-3.263zM116.464 21.277h-6.422V9.837h6.167v1.612h-4.268v3.238h3.933v1.604h-3.933v3.382h4.523zM104.393 21.19q-.543.27-1.429.27-2.376 0-2.377-2.28v-4.62h-1.363V13.11h1.363v-1.89l1.852-.527v2.417h1.954v1.452h-1.954v4.084q0 .726.263 1.037.262.31.877.311.47 0 .814-.271zM99.097 10.691a1.7 1.7 0 0 0-.853-.215q-1.35 0-1.349 1.523v1.11h1.899v1.451h-1.89v6.717h-1.851V14.56h-1.396v-1.452h1.396v-1.324q0-1.293.845-2.034.846-.75 2.114-.75.687 0 1.085.152zM88.933 21.468q-1.89 0-3.024-1.14-1.124-1.15-1.124-3.04 0-2.058 1.172-3.214 1.181-1.157 3.175-1.157 1.914 0 2.984 1.125 1.069 1.125 1.069 3.119 0 1.954-1.157 3.135-1.15 1.173-3.095 1.172m.087-7.075q-1.084 0-1.715.757-.63.758-.63 2.09 0 1.285.638 2.027.639.734 1.707.734 1.093 0 1.676-.726.59-.726.59-2.066 0-1.35-.59-2.082-.583-.735-1.675-.734M78.076 21.022v-1.715q1.038.79 2.29.79 1.675 0 1.675-.99a.76.76 0 0 0-.144-.47 1.3 1.3 0 0 0-.39-.352q-.24-.15-.575-.27-.327-.12-.734-.272a8 8 0 0 1-.91-.423 3 3 0 0 1-.67-.502 2 2 0 0 1-.398-.646 2.4 2.4 0 0 1-.136-.838q0-.591.28-1.037.279-.455.75-.758.47-.31 1.068-.463a4.8 4.8 0 0 1 1.237-.159q1.132 0 2.026.343v1.62q-.861-.591-1.978-.591a2.6 2.6 0 0 0-.638.072 1.6 1.6 0 0 0-.48.2 1 1 0 0 0-.31.31.7.7 0 0 0-.112.391q0 .264.112.447.111.183.327.327.223.135.526.255.311.112.71.248.526.215.942.438.421.225.718.51.294.28.454.655.16.367.16.878 0 .622-.287 1.084a2.4 2.4 0 0 1-.766.766q-.48.303-1.109.447a5.5 5.5 0 0 1-1.316.151q-1.34 0-2.322-.446M72.772 21.468q-1.89 0-3.023-1.14-1.125-1.15-1.125-3.04 0-2.058 1.172-3.214 1.181-1.157 3.175-1.157 1.915 0 2.984 1.125t1.069 3.119q0 1.954-1.157 3.135-1.148 1.173-3.095 1.172m.088-7.075q-1.085 0-1.715.757-.63.758-.63 2.09 0 1.285.638 2.027.637.734 1.707.734 1.093 0 1.675-.726.59-.726.59-2.066 0-1.35-.59-2.082-.583-.735-1.675-.734M68.312 14.87q-.336-.262-.965-.262-.822 0-1.373.742-.55.741-.55 2.018v3.909h-1.85v-8.169h1.85v1.683h.032q.27-.861.83-1.34.566-.487 1.26-.487.502 0 .766.152zM62.057 20.902q-.981.567-2.321.566-1.819 0-2.936-1.132-1.117-1.14-1.117-2.952 0-2.018 1.197-3.239 1.204-1.228 3.214-1.228 1.118 0 1.97.39v1.724q-.852-.638-1.818-.638-1.172 0-1.922.797-.75.79-.75 2.075 0 1.267.702 2.002.71.734 1.898.734.998 0 1.883-.71zM53.193 11.393q-.454 0-.782-.295a.98.98 0 0 1-.319-.75q0-.455.32-.758a1.1 1.1 0 0 1 .781-.303q.471 0 .798.303a1 1 0 0 1 .327.758.99.99 0 0 1-.327.742 1.13 1.13 0 0 1-.798.303m.918 9.884H52.26v-8.169h1.85zM49.971 21.277h-1.882v-7.403q0-.91.111-2.226h-.032q-.175.75-.31 1.077l-3.415 8.552h-1.308l-3.423-8.488q-.142-.375-.303-1.14h-.032q.064.686.064 2.24v7.388h-1.755V9.837h2.673l3.007 7.619q.343.877.447 1.308h.04q.294-.902.478-1.34l3.063-7.587h2.577z"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_486_39109">
          <path fill="currentColor" d="M0 0h145v30H0z"></path>
        </clipPath>
        <clipPath id="clip1_486_39109">
          <path fill="currentColor" d="M0 .5h160v30H0z"></path>
        </clipPath>
        <linearGradient
          id="paint0_linear_486_39109"
          x1="2.94"
          x2="10.322"
          y1="9.106"
          y2="21.892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18884F"></stop>
          <stop offset="0.5" stopColor="#117E43"></stop>
          <stop offset="1" stopColor="#0B6631"></stop>
        </linearGradient>
      </defs>
    </svg>
  </div>
)

export default MicrosoftExcelLogo
